import { useEffect, useId, useState } from 'react';

interface Props {
  value: string;
  label?: string;
  rows?: number;
  minRows?: number;
  maxRows?: number;
  onChange: (value: string) => void;
  placeholder?: string;
  isError?: boolean;
  errorMessage?: string;
}

export function Textarea(props: Props) {
  const id = useId();
  const {
    value,
    label,
    rows = 4,
    minRows = 3,
    maxRows = 6,
    onChange,
    placeholder,
    isError,
    errorMessage,
  } = props;

  const [showError, setShowError] = useState(!!isError);

  useEffect(() => {
    let timer: number;
    if (isError) {
      setShowError(true);
      timer = window.setTimeout(() => {
        setShowError(false);
      }, 2000); // Error message fades out after 2 seconds
    } else {
      setShowError(false);
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [isError]);

  return (
    <div className="relative">
      <label className="block" htmlFor={id}>
        {label && (
          <span className="dark:text-dark-secondary-text mb-1 block text-sm text-gray-700">
            {label}
          </span>
        )}
        <textarea
          rows={rows}
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={isError ? '' : placeholder}
          style={{
            minHeight: `calc(${minRows} * 1.5em + 0.5rem)`,
            maxHeight: `calc(${maxRows} * 1.5em + 0.5rem)`,
          }}
          className={`focus:border-primary-500 focus:ring-primary-500 dark:bg-dark-bg dark:border-dark-border-surface block w-full resize-y
            rounded-md border shadow-sm sm:text-sm
            ${
              isError
                ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
                : 'border-gray-300'
            }`}
        />
      </label>
      {showError && errorMessage && (
        <span className="pointer-events-none absolute left-2 top-4 text-sm text-red-500 opacity-90 transition-opacity duration-500">
          {errorMessage}
        </span>
      )}
    </div>
  );
}

export default Textarea;
